// Task #2327 — Blocco "ragionamento" collassabile stile Claude per la chat PA.
// Mostra il testo del thinking dell'AI: durante lo streaming è espanso con
// spinner e header "Sto ragionando…"; per i messaggi storici è collassato di
// default con header "Ragionamento" e riapribile al click. Non renderizza
// nulla se non c'è testo (degradazione silenziosa).
import React, { useEffect, useRef, useState } from 'react';
import { Brain, ChevronDown, ChevronRight, Loader2 } from 'lucide-react';

interface ReasoningBlockProps {
  thinking: string;
  /** True mentre la risposta è ancora in streaming (header animato, auto-espanso). */
  live?: boolean;
}

export const ReasoningBlock: React.FC<ReasoningBlockProps> = ({ thinking, live = false }) => {
  // Live: espanso di default per mostrare il testo che scorre. Storico: collassato.
  const [open, setOpen] = useState<boolean>(live);
  const bodyRef = useRef<HTMLDivElement>(null);

  // Auto-scroll al fondo mentre il ragionamento scorre in streaming.
  useEffect(() => {
    if (live && open && bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [thinking, live, open]);

  const text = (thinking || '').trim();
  if (!text) return null;

  return (
    <div className="mb-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/70 dark:bg-gray-800/30 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1.5 w-full px-2.5 py-1.5 text-left text-gray-600 dark:text-gray-300 hover:bg-gray-100/70 dark:hover:bg-gray-700/40 transition-colors"
      >
        {live ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" />
        ) : (
          <Brain className="h-3.5 w-3.5 shrink-0" />
        )}
        <span className="text-xs font-medium">
          {live ? 'Sto ragionando…' : 'Ragionamento'}
        </span>
        <span className="ml-auto shrink-0">
          {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        </span>
      </button>
      {open && (
        <div
          ref={bodyRef}
          className="px-2.5 pb-2 pt-0.5 max-h-56 overflow-y-auto text-[11px] leading-relaxed text-gray-600 dark:text-gray-300 whitespace-pre-wrap break-words font-mono"
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default ReasoningBlock;
